<template>
	<div class="page-header">
		<h2 class="page-header__title">
			{{ title }}
		</h2>
		<h4
			v-if="subtitle"
			class="page-header__subtitle"
		>
			{{ subtitle }}
		</h4>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			required: false,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped src="./header.scss" />
